import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Pipe({ name: 'sanitizeStyle' })
export class SanitizeStylePipe implements PipeTransform {
    private sanitizer = inject(DomSanitizer);

    transform(value: string): SafeStyle {
        return this.sanitizer.bypassSecurityTrustStyle(value);
    }
}
